export default "__VITE_ASSET__DSATmV8j__"